import { render, staticRenderFns } from "./CustomerGroupSingle.vue?vue&type=template&id=37fc8afa&"
import script from "./CustomerGroupSingle.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports